import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { BehaviorSubject, Observable, Subject, Subscription } from "rxjs";
import { STEP_STATE, StepperSelectionEvent } from "@angular/cdk/stepper";
import { ToastService, indicate } from "maps-angular-components";

import { CadastroRegraComponent } from "../../cadastro-regra/cadastro-regra.component";
import { FormGroup } from "@angular/forms";
import { MatStepper } from "@angular/material/stepper";
import {Regra} from '../../regra';
import { RegraService } from "../../regra.service";
import { SelecaoRegrasComponent } from "../../selecao-regras/selecao-regras.component";

@Component({
  selector: "regra-composta-stepper",
  templateUrl: "./regra-composta-stepper.component.html",
  styleUrls: ["./regra-composta-stepper.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegraCompostaStepperComponent
  implements OnInit, AfterViewInit, OnDestroy {
  private readonly subscriptions = new Subscription();

  @Input() regra: Regra;
  @Input() isConsulta = false ;

  @Output()
  closeDialog: EventEmitter<any> = new EventEmitter<any>();

  form: FormGroup;

  regrasAssociadas$: BehaviorSubject<Regra[]> = new BehaviorSubject([]);
  isCadastroRegraValid$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  isValid$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  loading$: Subject<boolean> = new Subject<boolean>();

  @ViewChild("cadastroRegraComposta", { static: false })
  cadastroRegra: CadastroRegraComponent;

  @ViewChild("selecaoRegras", { static: false })
  selecaoRegras: SelecaoRegrasComponent;

  @ViewChild("stepper", { static: true })
  public stepper: MatStepper;

  constructor(
    private readonly regraService: RegraService,
    private readonly messageService: ToastService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngAfterViewInit(): void {
    this.stepper._getIndicatorType = () => STEP_STATE.NUMBER;
    this.changeDetectorRef.detectChanges();
  }

  ngOnInit() {
    this.isCadastroRegraValid$.next(false);

    this.isCadastroRegraValid$.subscribe(value => {
      this.isValid$.next(value === true && this.regrasAssociadas$.getValue().length > 0)
    });

    this.regrasAssociadas$.subscribe(value => {
      this.isValid$.next(this.isCadastroRegraValid$.getValue() === true && value.length > 1)
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  updateRegrasAssociadas(regras: Regra[]) {
    this.regrasAssociadas$.next(regras);
  }

  updateForm(formGroup: FormGroup) {
    this.form = formGroup;
    this.checkCadastroRegrasValid(this.form.valid);
  }

  private checkCadastroRegrasValid(isValid: boolean) {
    this.isCadastroRegraValid$.next(isValid);
  }

  limpar() {
    this.stepper.reset();
    this.cadastroRegra.limparForm();
    this.selecaoRegras.clear();
    this.regrasAssociadas$.next([]);
  }

  stepChanged($event: StepperSelectionEvent): void {

  }

  gravar() {
    const regrasAssociadas = this.regrasAssociadas$.getValue();

    const _regra: Regra = this.regraService.montarRegra(this.form, regrasAssociadas, this.cadastroRegra.funcaoSelecionada);

    if (this.regra) {
      _regra.id = this.regra.id;
      this.regraService.alterarRegraComposta(_regra).pipe(
        indicate(this.loading$)
      ).subscribe(
        () => {
          this.messageService.textoLight("Regra atualizada com sucesso.");
          this.limpar();
          this.closeDialog.emit();
        },
        err => this.messageService.erro(err.error.message)
      );
    } else {
      this.regraService.gravarComposta(_regra).pipe(
        indicate(this.loading$)
      ).subscribe(
        () => {
          this.messageService.textoLight("Regra cadastrada com sucesso.");
          this.limpar();
          this.closeDialog.emit();
        },
        err => this.messageService.erro(err.error.message)
      );
    }
  }
}
